import {Injectable} from "@angular/core";
import {MessageControlDto} from "@server-models";
import {Observable} from "rxjs";
import {SharedIssueApiService} from "@shared/components/issues/services/shared-issue-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";

@Injectable({
  providedIn: 'root',
})
export class LinkIssueControlMessageApiService extends SharedIssueApiService implements IIssueService {

  getIssuePreview(templateId: number): Observable<any> {
    return super.get<any>(`/tech/v2/issue/message-control/template/${ templateId }/preview`, undefined);
  }

  getIssue(issueId: number): Observable<MessageControlDto> {
    return super.get<MessageControlDto>(`/tech/v2/issue/message-control/${ issueId }/recent`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: any): Observable<void> {
    return super.post<void>(`/tech/v2/issue/message-control/template/${ templateId }/submitIssue`, undefined, issue);
  }

}
